import {
  AsiaAreaId,
  LangType,
  SubmitAddressIdMap,
  TestAreaId,
  rules,
} from './const';
import { i18n } from '../main';
import { languageArr } from './setLanguage';
export const isInIntlBrowser = /intlbrowser/i.test(navigator.userAgent);
export const IsTest =
  location.origin.includes('test') || location.origin.includes('localhost');

export const AreaId = !IsTest ? AsiaAreaId : TestAreaId;
// detect navigator share
// todo: files && other
export function canUseNavigatorShare(text: string) {
  return navigator.canShare && navigator.canShare({ text });
}

export function dataURLtoFile(dataurl: any, filename: string) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return {
    file: new File([u8arr], filename, { type: mime }),
    blob: new Blob([u8arr], { type: mime }),
  };
}

export enum LoginErrorCode {
  ACCOUNT_NOT_VALID = 2001,
  ACCOUNT_NOT_EXIST = 2200,
  ACCOUNT_NOT_RIGHT = 2002,
  PASSWORD_EMPTY = 2108,
  PASSWORD_NOT_SET = 808099001,
}

export const getErrMessage = (code: LoginErrorCode) => {
  const map = {
    [LoginErrorCode.ACCOUNT_NOT_VALID]: i18n.t('account_not_exist'),
    [LoginErrorCode.ACCOUNT_NOT_EXIST]: i18n.t('account_not_exist'),
    [LoginErrorCode.PASSWORD_EMPTY]: i18n.t('password_empty'),
    [LoginErrorCode.ACCOUNT_NOT_RIGHT]: i18n.t('pls_input_info'),
    [LoginErrorCode.PASSWORD_NOT_SET]: i18n.t('pls_input_info'),
  };
  return map[code] ?? i18n.t('error');
};
function transformUrlLangType() {
  const urlData = new URL(window.location.href);
  const urlLangType =
    urlData.searchParams.get('lang_type') ||
    urlData.searchParams.get('slanguage');
  console.log('urlLangType', urlLangType);
  return transformLangType(urlLangType);
}
function transformNavigatorLangType() {
  const navigatorLan = navigator.language;
  console.log('navigatorLan', navigatorLan);
  return transformLangType(navigatorLan);
}
function transformLangType(urlLangType: string | undefined | null) {
  if (!urlLangType) return urlLangType;
  const langTypeTrans = [
    { urlKey: 'zh-CN', wandKey: 'zh' },
    { urlKey: 'zh-TW', wandKey: 'zh' },
    { urlKey: 'en-US', wandKey: 'en' },
  ];
  const realLangData = langTypeTrans.find((item) => {
    if (!item.urlKey) return false;
    return item.urlKey.toLowerCase() === urlLangType.toLowerCase();
  });
  if (!realLangData) return urlLangType;
  return realLangData.wandKey;
}
export function getLang(): string {
  // url语言
  const urlLang = transformUrlLangType();
  const isValidUrlLang = languageArr.find((item) => item.value === urlLang);
  if (isValidUrlLang) return isValidUrlLang.value;
  // 缓存语言
  const cacheLang = localStorage.getItem('localeLanguage');
  const isValidCacheLang = languageArr.find((item) => item.value === cacheLang);
  if (isValidCacheLang) return isValidCacheLang.value;
  // 浏览器语言
  const navigatorLan = transformNavigatorLangType();
  const isValidNavigatorLan = languageArr.find(
    (item) => item.value === navigatorLan
  );
  if (isValidNavigatorLan) return isValidNavigatorLan.value;
  return 'en';
}

export function switchLang(lang: LangType): void {
  const prodMap = {
    ko: 'kr',
    ja: 'jp',
    en: 'en',
    th: 'sea',
  };
  const nowPath = `nikke-${(
    prodMap[getLang() as keyof typeof prodMap] || 'en'
  ).toLowerCase()}`;
  const newPath = `nikke-${(
    prodMap[lang as keyof typeof prodMap] || 'en'
  ).toLowerCase()}`;
  console.log('switchLang=======', nowPath, newPath);
  location.href = location.href.replace(nowPath, newPath);
}
export function urlparamsToObject() {
  const res: Record<string, string> = {};
  const urlparams = new URLSearchParams(location.search);
  urlparams.forEach((val, key) => {
    res[key] = val;
  });
  return res;
}

export function getSpecialBrowserType() {
  const uaTester = (regs: RegExp[]) =>
    Boolean(regs.find((reg) => reg.test(navigator.userAgent)));
  if (uaTester([/fbav/i, /fban/i])) {
    return 'facebook';
  }
  if (uaTester([/naver/i, /fban/i])) {
    return 'naver';
  }
  if (uaTester([/bytelo/i, /bytedance/i])) {
    return 'tictok';
  }
  if (uaTester([/microm/i, /wechat/i])) {
    return 'wechat';
  }
  if (uaTester([/vivobrowser/i, /vivo/i])) {
    return 'vivo';
  }
  if (uaTester([/mibrowser/i, /xiaomi/i, /miui/i])) {
    return 'mi';
  }
  if (uaTester([/discord/i])) {
    return 'discord';
  }
  if (uaTester([/kakao/i, /kakaotalk/i])) {
    return 'kakao';
  }
  if (uaTester([/line/i])) {
    return 'line';
  }
  if (uaTester([/instagram/i])) {
    return 'ins';
  }
  return '';
}

export function appendScript(script: string) {
  return new Promise((resolve, reject) => {
    const head = document.getElementsByTagName('head')[0];
    const wsScript = document.createElement('script');
    wsScript.type = 'text/javascript';
    wsScript.src = script;

    head.appendChild(wsScript);
    const scriptLoaded = (e: Event) => {
      wsScript.removeEventListener('load', scriptLoaded);
      resolve(e);
    };
    const scriptLoadFailed = (e: Event) => {
      wsScript.removeEventListener('error', scriptLoadFailed);
      reject(e);
    };
    wsScript.addEventListener('load', scriptLoaded);
    wsScript.addEventListener('error', scriptLoadFailed);
    wsScript.addEventListener('abort', scriptLoadFailed);
  });
}

export function appendLink(script: string) {
  return new Promise((resolve, reject) => {
    const head = document.getElementsByTagName('head')[0];
    const wsScript = document.createElement('link');
    wsScript.rel = 'stylesheet';
    wsScript.href = script;

    head.appendChild(wsScript);
    const scriptLoaded = (e: Event) => {
      wsScript.removeEventListener('load', scriptLoaded);
      resolve(e);
    };
    const scriptLoadFailed = (e: Event) => {
      wsScript.removeEventListener('error', scriptLoadFailed);
      reject(e);
    };
    wsScript.addEventListener('load', scriptLoaded);
    wsScript.addEventListener('error', scriptLoadFailed);
    wsScript.addEventListener('abort', scriptLoadFailed);
  });
}

export async function getServerInfo() {
  if (!(window as any).TRSSJServerSelect) {
    await appendScript(
      'https://trl.tarisglobal.com/game_area/en/trssj_server_select_utf8.js'
    );
  }
  return (window as any).TRSSJServerSelect;
}

export async function getSeverList() {
  const serverInfo = await getServerInfo();
  const serverList = [AreaId];
  return serverList.map((serverId) => {
    const area =
      serverInfo.STD_CHANNEL_DATA.find((item: any) => item.v === serverId) ||
      {};
    const server = serverInfo.STD_DATA.filter(
      (item: any) => item.c === serverId
    );
    console.log('接口 getSeverList ===', { ...area, server });
    return {
      ...area,
      server,
    };
  });
}

function showInputTips(key: string, value: string) {
  const domInfo = SubmitAddressIdMap[key as keyof typeof SubmitAddressIdMap];
  const dom = window.$(domInfo.selector)?.next();
  if (!dom) return;
  if (!value) {
    dom.hide();
    return;
  }
  dom.text(value).show();
}
export function checkKeyInput(
  key: string,
  val: string,
  langData: Record<string, string>
) {
  const rule = rules[key as keyof typeof rules] || [];
  if (!rule) return true;
  for (const ruleInfo of rule) {
    const { message: text } = ruleInfo;
    const message = langData[text] || text;
    if (ruleInfo.required && !val) {
      showInputTips(key, message);
      return false;
    }
    if (ruleInfo.min && val.length < ruleInfo.min) {
      showInputTips(key, message);
      return false;
    }
    if (ruleInfo.max && val.length > ruleInfo.max) {
      showInputTips(key, message);
      return false;
    }
    if (ruleInfo.regex) {
      const regex = new RegExp(ruleInfo.regex);
      if (!regex.test(val)) {
        showInputTips(key, message);
        return false;
      }
    }
    showInputTips(key, '');
  }
  return true;
}

const params = new URLSearchParams(location.search);
// export const ENV =  location.origin.includes('test') && params.get('env') !== 'prod'
//   ? 'test';
/** 亚服 */
export const isSea =
  location.pathname.split('/').includes('sea') || params.get('zone') === 'sea';
/** 北美 */
export const isEu =
  location.pathname.split('/').includes('eu_am') ||
  params.get('zone') === 'eu_am';

export const getRegion = () => {
  if (isSea) return 'sea';
  if (isEu) return 'eu_am';
  return 'sea';
};

export const REGION_AREA = isSea ? ['ASIA'] : ['EU', 'EE', 'LATAM', 'NA'];

/** 返回UTC时间 */
export const unixToUTC = ({ timestamp }: { timestamp: number }) => {
  const date = new Date(timestamp * 1000); // JavaScript 的 Date 对象需要以毫秒为单位的时间戳
  // const utcString = date.toUTCString();
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1; // getUTCMonth() 返回的是 0-11，所以需要加 1
  const day = date.getUTCDate();
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();

  const formattedUtcTime = `${year}-${month.toString().padStart(2, '0')}-${day
    .toString()
    .padStart(2, '0')} ${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return formattedUtcTime;
};

/** 隐私邮箱地址： luo_zeyu@qq.com => luo*****y@qq.com */
export const obfuscateEmail = (email: string) => {
  const emailRegex = /^([a-zA-Z0-9._%+-]+)@([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
  const match = email.match(emailRegex);
  if (match) {
    const username = match[1];
    const domain = match[2];
    const usernameLength = username.length;
    // 保留用户名的首尾字符，中间部分替换为星号
    const obfuscatedUsername =
      username.slice(0, 3) + '*'.repeat(5) + username[usernameLength - 1];
    return `${obfuscatedUsername}@${domain}`;
  }
  return email; // 如果不是有效的电子邮件地址，则返回原始字符串
};

const getPlatform = (): 'Android' | 'iOS' | 'Unknown' => {
  const userAgent = navigator.userAgent;
  if (/android/i.test(userAgent)) {
    return 'Android';
  }
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'iOS';
  }

  return 'Unknown';
};
const selectText = (textbox: any, startIndex: number, stopIndex: number) => {
  if (textbox.createTextRange) {
    const range = textbox.createTextRange();
    range.collapse(true);
    range.moveStart('character', startIndex);
    range.moveEnd('character', stopIndex - startIndex);
    range.select();
  } else {
    textbox.setSelectionRange(startIndex, stopIndex);
    textbox.focus();
  }
};

const fallbackCopyToClipboard = (text: string) => {
  return new Promise((resolve) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      resolve(successful);
      const msg = successful ? 'successful' : 'unsuccessful';
      console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
      resolve(false);
    }

    document.body.removeChild(textArea);
  });
};
export const copyToClipboard = (str: string) => {
  console.log('copyToClipboard', str);
  return new Promise((resolve) => {
    const platform = getPlatform();
    if (platform === 'Android' || platform === 'iOS') {
      if (platform === 'Android') {
        const currentInput = document.createElement('input');
        currentInput.value = str;
        document.body.appendChild(currentInput);
        currentInput.select();
        document.execCommand('copy');
        document.body.removeChild(currentInput);
        if (document.execCommand('copy')) {
          // console.log('复制成功');
          resolve(true);
        } else {
          // console.log('复制失败');
          resolve(false);
        }
      }
      if (platform === 'iOS') {
        const textString = str.toString();
        let input: HTMLInputElement | null =
          document.querySelector('#copy-input');
        if (!input) {
          input = document.createElement('input');
          input.id = 'copy-input';
          input.readOnly = true;
          input.style.position = 'absolute';
          input.style.top = '-100px';
          input.style.left = '-1000px';
          input.style.zIndex = '-1000';
          document.body.appendChild(input);
        }

        input.value = textString;
        selectText(input, 0, textString.length);
        if (document.execCommand('copy')) {
          document.execCommand('copy');
          // console.log('复制成功');
          resolve(true);
        } else {
          // console.log('复制失败');
          resolve(false);
        }
        input.blur();
        document.body.removeChild(input);
      }
    } else {
      if (navigator.clipboard) {
        const type = 'text/plain';
        const blob = new Blob([str], { type });
        const data = [new ClipboardItem({ [type]: blob })];
        navigator.clipboard.write(data).then(
          () => {
            /* success */
            resolve(true);
          },
          () => {
            /* failure */
            resolve(false);
          }
        );
      } else {
        fallbackCopyToClipboard(str);
      }
    }
  });
};
